import { ADD_BUSINESS_TYPE, DELETE_BUSINESS_TYPE, GET_BUSINESS_TYPES, UPDATE_BUSINESS_TYPE, UPDATE_BUSINESS_TYPE_STATUS } from "../types";



const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_BUSINESS_TYPES:
            return {...state, list: payload};

        case UPDATE_BUSINESS_TYPE:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case UPDATE_BUSINESS_TYPE_STATUS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case ADD_BUSINESS_TYPE:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_BUSINESS_TYPE:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
